<app-navbar class="mat-elevation-z6"></app-navbar>
<div class="h-full w-full flex justify-center layout-container">
    <router-outlet></router-outlet>
</div>
